import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link, Stack } from '@mui/material';

const NotFound: React.FC = () => {
  return (
    <Stack
      id='404'
      spacing={1}
      sx={{ height: '100vh', justifyContent: 'center', alignItems: 'center', bgcolor: 'background.default' }}
    >
      <Typography variant='h2' color='typography.light'>
        404 Not Found
      </Typography>
      <Typography variant='p2' color='typography.light'>
        Valitettavasti emme löydä tätä sivua.
      </Typography>
      <Typography variant='p1'>
        <Link component={RouterLink} to='/'>
          Etusivulle
        </Link>
      </Typography>
    </Stack>
  );
};

export default NotFound;
